import { ReactNode } from 'react';
import { Title1, Body1, tokens } from '@fluentui/react-components';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div
      style={{
        display:        'flex',
        alignItems:     'flex-start',
        justifyContent: 'space-between',
        marginBottom:   24,
        gap:            16,
        // v2026.06.107 - flex-wrap container pour eviter overflow horizontal
        // sur ecrans moyens (1280-1440px). Les actions descendent sous le titre
        // plutot que deborder du viewport.
        flexWrap:       'wrap',
      }}
    >
      <div style={{ flex: '1 1 320px', minWidth: 0 }}>
        <Title1>{title}</Title1>
        {description && (
          <Body1 style={{ display: 'block', marginTop: 4, color: tokens.colorNeutralForeground3 }}>
            {description}
          </Body1>
        )}
      </div>
      {actions && (
        <div style={{
          display:    'flex',
          gap:        8,
          flexWrap:   'wrap',
          flexShrink: 0,
        }}>
          {actions}
        </div>
      )}
    </div>
  );
}
